import React, { useEffect, useState } from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import AdminApi from '../../../../api/admin-api/admin-api.js'
import EliteAgencyTeamService from '../../../../shared/services/EliteAgencyTeam.service.js'
import './LeaderboardTeamFilter.scss'

const LeaderboardTeamFilter = ({ config, setConfig, rows = [] }) => {
  const [allOptions, setAllOptions] = useState([])
  const [options, setOptions] = useState([])

  const isSigAgents = config?.agent_type === 'user_id'
  const isCareerAgents = config?.agent_type === 'sub_agent_id'
  const selectedValue = isSigAgents ? config?.division_id || '' : config?.team_id || ''

  // Fetch all options when agent_type changes
  useEffect(() => {
    setAllOptions([])
    setOptions([])

    if (isSigAgents) {
      AdminApi.getDivisions()
        .then(res => {
          const list = res?.data?.data
          if (Array.isArray(list)) {
            setAllOptions(
              list.map(d => ({ value: `${d.id}`, label: d.d_name })).sort((a, b) => a.label.localeCompare(b.label))
            )
          }
        })
        .catch(() => {})
    } else if (isCareerAgents) {
      EliteAgencyTeamService.search({ pagination: false })
        .then(res => {
          let teams = []
          if (res?.models && Array.isArray(res.models)) teams = res.models
          else if (res?.data && Array.isArray(res.data)) teams = res.data
          else if (res?.payload && Array.isArray(res.payload)) teams = res.payload
          setAllOptions(
            teams.map(t => ({ value: `${t.id}`, label: t.team_name })).sort((a, b) => a.label.localeCompare(b.label))
          )
        })
        .catch(() => {})
    }
  }, [config?.agent_type])

  // Re-filter whenever allOptions or rows change.
  // Skip re-filtering while a selection is active to avoid shrinking the list.
  useEffect(() => {
    if (!allOptions.length) {
      setOptions([])
      return
    }
    if (selectedValue) return

    if (isSigAgents) {
      const activeDivIds = new Set(rows.map(r => `${r.div_id}`).filter(Boolean))
      setOptions(allOptions.filter(o => activeDivIds.has(o.value)))
    } else if (isCareerAgents) {
      const activeTeamNames = new Set(rows.map(r => r.team_name).filter(Boolean))
      setOptions(allOptions.filter(o => activeTeamNames.has(o.label)))
    }
  }, [allOptions, rows, selectedValue, isSigAgents, isCareerAgents])

  const handleChange = e => {
    const val = e.target.value || null
    setConfig(isSigAgents ? { division_id: val } : { team_id: val })
  }

  const handleClear = () => {
    setConfig(isSigAgents ? { division_id: null } : { team_id: null })
  }

  if (!isSigAgents && !isCareerAgents) return null

  return (
    <div className='leaderboard-team-filter'>
      <select className='team-filter-select' value={selectedValue} onChange={handleChange}>
        <option value=''>{isSigAgents ? 'All Divisions' : 'All Elite Agency Teams'}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {selectedValue && (
        <button className='team-filter-clear' onClick={handleClear} type='button' title='Clear filter'>
          <MDBIcon icon='times' />
        </button>
      )}
    </div>
  )
}

export default LeaderboardTeamFilter
